import { render, staticRenderFns } from "./CartProductCartouche.vue?vue&type=template&id=20561a0c&scoped=true"
import script from "./CartProductCartouche.vue?vue&type=script&lang=js"
export * from "./CartProductCartouche.vue?vue&type=script&lang=js"
import style0 from "./CartProductCartouche.vue?vue&type=style&index=0&id=20561a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20561a0c",
  null
  
)

export default component.exports